module.exports = __webpack_public_path__ + "static/media/Logo-agrofesa.93776857.gif";